<app-document-advance-payments-list-widget
    *ngIf="model?.id"
    #addEditAdvancePaymentsWidget
    [document]="model"
    [documentId]="model?.id"
    [documentProject]="documentProject"
    (documentChanged)="onDocumentChanged()"
></app-document-advance-payments-list-widget>
